import { Component, OnInit } from '@angular/core';
import { DialogConfig, DialogRef } from '@tylertech/forge-angular';
import { Constants } from 'app/meeting-manager/lib/constants';


@Component({
    selector: 'appc-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    standalone: false,
})
export class DialogComponent implements OnInit {
    constructor(
        public dialogConfig: DialogConfig,
        public _dialogRef: DialogRef,
        public constants: Constants
    ) {
    }

    /**
     * Angular ngOnInit lifecycle method
     */
    ngOnInit() {
    }

    cancelClicked() {
        this._dialogRef.close(this.constants.forgeDialog.returnData.cancelText);
    }

    okClicked() {
        this._dialogRef.close(this.constants.forgeDialog.returnData.okText);
    }
    optionalButtonClicked() {
        this._dialogRef.close(this.constants.forgeDialog.returnData.optionalButtonText);
    }
}
